import React, { useState } from "react";
import { users } from "../../staticData/users";

import "./loginForm.css";

const LoginForm = ({ setAuthenticated, setUserRole }) => {
  const [usernameInput, setUsernameInput] = useState("");
  const [passwordInput, setPasswordInput] = useState("");

  const handleInputChange = (event) => {
    let input = event.target.value;
    if (event.target.name === "username") {
      setUsernameInput(input);
    } else if (event.target.name === "password") {
      setPasswordInput(input);
    }
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();

    let payload = {
      username: usernameInput,
      password: passwordInput
    };
    try {
      let correct = false;

      for (let i = 0; i < users.length; i++) {
        if (
          users[i].username === payload.username &&
          users[i].password === payload.password
        ) {
          correct = true;
          break;
        }
      }

      if (correct) {
        setUsernameInput("");
        setPasswordInput("");

        setAuthenticated(true);
        setUserRole(payload.username === "admin" ? 0 : 1);
      } else {
        throw new Error("Invalid credentials");
      }
    } catch (err) {
      console.log(err);
      alert("Invalid credentials");
    }
  };

  return (
    <form className="loginPage__loginForm" onSubmit={handleLoginSubmit}>
      <label htmlFor="username">
        <input
          type="text"
          name="username"
          id="username"
          placeholder="username"
          onChange={handleInputChange}
        />
      </label>
      <label htmlFor="password">
        <input
          type="password"
          name="password"
          id="password"
          placeholder="password"
          onChange={handleInputChange}
        />
      </label>
      <input type="submit" value="Submit" />
    </form>
  );
};

export default LoginForm;
